module.exports = __webpack_public_path__ + "static/media/nohistory.79e6b86e.svg";